// ======================================================================
// File Name       : TopScreenSetting
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Col, Form } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';

class TopScreenSetting extends Component {
  render() {
    const { formValues } = this.props;
    let topSetting = null;
    if (formValues && formValues.values) {
      const { heroAreaFlag, bannerFlag1, bannerFlag2, bannerFlag3, bannerUrl1, bannerUrl2, bannerUrl3,
      } = formValues.values;
      topSetting = (
        <>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col as={Form.Label} sm={2}>メインビジュアル</Col>
              <Col className="margin-top-7" sm={2}>
                <RenderField
                  type="checkbox"
                  name="heroAreaFlag"
                  label="表示する"
                  normalizeRadio
                  value={heroAreaFlag}
                />
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col as={Form.Label} sm={2}>バナー1</Col>
              <Col className="margin-top-7" sm={2}>
                <RenderField
                  type="checkbox"
                  name="bannerFlag1"
                  label="表示する"
                  normalizeRadio
                  value={bannerFlag1}
                />
              </Col>
              <Col as={Form.Label} sm={1} className="bold">
                リンク先
              </Col>
              <Col sm={3}>
                <RenderField
                  type="text"
                  name="bannerUrl1"
                  label="リンク先"
                  disabled={!bannerFlag1}
                  value={bannerUrl1}
                />
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col as={Form.Label} sm={2}>バナー2</Col>
              <Col className="margin-top-7" sm={2}>
                <RenderField
                  type="checkbox"
                  name="bannerFlag2"
                  label="表示する"
                  normalizeRadio
                  value={bannerFlag2}
                />
              </Col>
              <Col as={Form.Label} sm={1} className="bold">
                リンク先
              </Col>
              <Col sm={3}>
                <RenderField
                  type="text"
                  name="bannerUrl2"
                  label="リンク先"
                  disabled={!bannerFlag2}
                  value={bannerUrl2}
                />
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col as={Form.Label} sm={2}>バナー3</Col>
              <Col className="margin-top-7" sm={2}>
                <RenderField
                  type="checkbox"
                  name="bannerFlag3"
                  label="表示する"
                  normalizeRadio
                  value={bannerFlag3}
                />
              </Col>
              <Col as={Form.Label} sm={1} className="bold">
                リンク先
              </Col>
              <Col sm={3}>
                <RenderField
                  type="text"
                  name="bannerUrl3"
                  label="リンク先"
                  disabled={!bannerFlag3}
                  value={bannerUrl3}
                />
              </Col>
            </Col>
          </Form.Group>
        </>
      );
    }

    return <div>{topSetting}</div>;
  }
}

export default TopScreenSetting;
